var render = function render(){var _vm=this,_c=_vm._self._c;return _c('type-template',{attrs:{"acne-types":_vm.acneTypes,"concurrent-nodules":_vm.concurrentNodules,"has-nodules":_vm.hasNodules,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }